import styled from 'styled-components'
import { P as PKS, Div as DivKonsys } from 'konsys-ui'
import { DatePicker as DP, AutoComplete as AC } from 'antd'

export const Div = styled.div`
  position: absolute;
  top: -9px;
`

export const a = styled.div`
`

export const P = styled(PKS)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export const DatePicker = styled(DP)`
  width: 100%;
  >div {
    >input {
      height: 32px;
    }
  }
`

export const AutoComplete = styled(AC)`
  width: 100%;
  margin: 16px 0 8px 0;
  >div {
    .ant-input {
      height: 35px !important;
    }
  }
`

export const CardStyled = styled(DivKonsys)`
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
  box-shadow: 0px 5px 20px 5px rgba(185, 185, 185, 0.15);
  border-radius: 10px;
`
